/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Agent_ChangeInputs */

const cs_enum_agent_change = /** @type {(inputs: Enum_Agent_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna makléře`)
};

const en_enum_agent_change = /** @type {(inputs: Enum_Agent_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent change`)
};

/**
* | output |
* | --- |
* | "Agent change" |
*
* @param {Enum_Agent_ChangeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_agent_change = /** @type {((inputs?: Enum_Agent_ChangeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Agent_ChangeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_agent_change(inputs)
	return cs_enum_agent_change(inputs)
});